import { createPinia } from "pinia";
import App from "./App.ce.vue";

const piniaPlugin = {
  install(app) {
    app.use(createPinia());
  },
};

export const setup = () => Object.freeze({ component: App, plugins: [piniaPlugin] });
